import { Action } from '../../common/actions/core/action';
import { FamilyPlanTypes } from '../../common/services/package/package.model';

export class OpenAboutDialogAction implements Action {
  constructor(
   public type: FamilyPlanTypes
  ) {}
}



// WEBPACK FOOTER //
// src/app/family-plan/family-plan-about-dialog/family-plan-about-dialog.action.ts